export const CLIENT_STATUS ="CLIENT_STATUS"
export const CLIENT_STATUS_SUCCESS ="CLIENT_STATUS_SUCCESS"
export const CLIENT_STATUS_FAIL ="CLIENT_STATUS_FAIL"